import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { changeInviteStatus, getInviteData } from "../../Redux/Actions/invitesAction";
import MainLayout from "../../Layout/mainLayout";
import "./viewInvite.css";

const ViewInvite = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getInviteData(id));
  }, [dispatch, id]);

  const { invite } = useSelector((state) => state.invites || {});
  const data = invite?.data || {};
  const [showAllAbout, setShowAllAbout] = useState(false);

  const statusOptions = ["requested", "pending", "declined", "accepted"];

  const statusColorMap = {
    accepted: "vi-status--accepted",
    declined: "vi-status--declined",
    pending: "vi-status--pending",
    requested: "vi-status--requested",
  };

  const currentStatus = data?.status?.toLowerCase() || "";

  return (
    <MainLayout>
      <div className="vi-wrapper">

        <div className="vi-header">
          <div className="vi-header-left">
            <Link to="/invites" className="vi-back-btn">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </Link>
            <div className="vi-header-divider" />
            <div>
              <div className="vi-breadcrumb">Invites / List / View</div>
              <h1 className="vi-title">{data?.event?.event_name || "Invite Details"}</h1>
            </div>
          </div>
          {currentStatus && (
            <span className={`vi-status-pill ${statusColorMap[currentStatus] || ""}`}>
              {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
            </span>
          )}
        </div>

        <div className="vi-hero-card">
          <div className="vi-hero-left">
            <div>
              <div className="vi-hero-label">Event</div>
              <div className="vi-hero-value">{data?.event?.event_name || "—"}</div>
            </div>
          </div>
          <div className="vi-hero-meta">
            {data?.user?.name && (
              <div className="vi-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                </svg>
                {data.user.name}
              </div>
            )}
            {data?.start_date && (
              <div className="vi-hero-meta-item">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                  <line x1="16" y1="2" x2="16" y2="6" />
                  <line x1="8" y1="2" x2="8" y2="6" />
                  <line x1="3" y1="10" x2="21" y2="10" />
                </svg>
                {data.start_date}
              </div>
            )}
          </div>
        </div>

        <div className="vi-grid-layout">

          <div className="vi-col">

            <div className="vi-card">
              <div className="vi-card-header">
                <span className="vi-card-badge">01</span>
                <h2 className="vi-card-title">User Details</h2>
              </div>
              <div className="vi-info-grid">
                <div className="vi-info-item">
                  <span className="vi-info-label">Full Name</span>
                  <span className="vi-info-value">{data?.user?.name || "No Data"}</span>
                </div>
                <div className="vi-info-item">
                  <span className="vi-info-label">Email</span>
                  <span className="vi-info-value">{data?.user?.email || "No Data"}</span>
                </div>
                <div className="vi-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vi-info-label">Contact Number</span>
                  <span className="vi-info-value">{data?.user?.contact_number || "No Data"}</span>
                </div>
              </div>
            </div>

            <div className="vi-card">
              <div className="vi-card-header">
                <span className="vi-card-badge">02</span>
                <h2 className="vi-card-title">Event Details</h2>
              </div>
              <div className="vi-info-grid">
                <div className="vi-info-item">
                  <span className="vi-info-label">Start Date</span>
                  <span className="vi-info-value">{data?.start_date || "No Data"}</span>
                </div>
                <div className="vi-info-item">
                  <span className="vi-info-label">End Date</span>
                  <span className="vi-info-value">{data?.end_date || "No Data"}</span>
                </div>
                <div className="vi-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vi-info-label">About Event</span>
                  {(() => {
                    const about = data?.event?.about_event || "";
                    const LIMIT = 200;
                    const isLong = about.length > LIMIT;
                    const displayed = isLong && !showAllAbout ? about.slice(0, LIMIT) + "…" : about;
                    return (
                      <>
                        <p className="vi-description">{displayed || "No Data"}</p>
                        {isLong && (
                          <div className="vi-view-more-wrap">
                            <button className="vi-view-more-btn" onClick={() => setShowAllAbout(!showAllAbout)}>
                              <span className="vi-chevron">{showAllAbout ? "▲" : "▼"}</span>
                              {showAllAbout ? "Show Less" : "Show All"}
                            </button>
                          </div>
                        )}
                      </>
                    );
                  })()}
                </div>
              </div>
            </div>

          </div>

          <div className="vi-col">

            <div className="vi-card">
              <div className="vi-card-header">
                <span className="vi-card-badge">03</span>
                <h2 className="vi-card-title">Address Details</h2>
              </div>
              <div className="vi-info-grid">
                <div className="vi-info-item" style={{ gridColumn: "span 2" }}>
                  <span className="vi-info-label">Street Address</span>
                  <span className="vi-info-value">{data?.address || "No Data"}</span>
                </div>
                <div className="vi-info-item">
                  <span className="vi-info-label">Country</span>
                  <span className="vi-info-value">{data?.country?.country_name || "No Data"}</span>
                </div>
                <div className="vi-info-item">
                  <span className="vi-info-label">City</span>
                  <span className="vi-info-value">{data?.city?.city_name || "No Data"}</span>
                </div>
              </div>
            </div>

            <div className="vi-card">
              <div className="vi-card-header">
                <span className="vi-card-badge">04</span>
                <h2 className="vi-card-title">Update Status</h2>
              </div>
              <div className="vi-info-item">
                <span className="vi-info-label">Current Status</span>
                {currentStatus && (
                  <span className={`vi-status-pill ${statusColorMap[currentStatus] || ""}`} style={{ width: "fit-content", marginBottom: "12px" }}>
                    {currentStatus.charAt(0).toUpperCase() + currentStatus.slice(1)}
                  </span>
                )}
                <span className="vi-info-label" style={{ marginTop: "4px" }}>Change Status</span>
                <div className="vi-select-wrap">
                  <select
                    className="vi-select"
                    defaultValue=""
                    onChange={(e) =>
                      dispatch(changeInviteStatus({ invite_id: id, status: e.target.value }))
                    }
                  >
                    <option value="" disabled>Select an option</option>
                    {statusOptions.map((s) => (
                      <option key={s} value={s}>
                        {s.charAt(0).toUpperCase() + s.slice(1)}
                      </option>
                    ))}
                  </select>
                  <svg className="vi-select-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </div>
              </div>
            </div>

            {Array.isArray(data?.guest_list) && data.guest_list.length > 0 && (
              <div className="vi-card">
                <div className="vi-card-header">
                  <span className="vi-card-badge">05</span>
                  <h2 className="vi-card-title">Guest Details</h2>
                </div>
                <div className="vi-guest-list">
                  {data.guest_list.map((guest, idx) => (
                    <div key={idx} className="vi-guest-item">
                      <div className="vi-guest-avatar">
                        {guest?.name?.charAt(0)?.toUpperCase() || "G"}
                      </div>
                      <div className="vi-guest-info">
                        <span className="vi-info-label">Guest {idx + 1}</span>
                        <span className="vi-info-value">{guest?.name || "No Data"}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewInvite;